import styled from '@emotion/styled';
import { IconButton } from '@mui/material';
import { Theme } from '@mui/material/styles';

export const StyledOverlay = styled.div<{ theme?: Theme; isDesktop: boolean }>`
  box-sizing: border-box;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  width: ${({ isDesktop }) => (isDesktop ? 'calc(100% - 80px)' : '100%')};
  z-index: 1000;
  background: ${({ theme }) => theme.palette.customSecondary.neutral.black}cc;
  backdrop-filter: blur(2px);
`;

export const StyledModalAsBanner = styled.div<{ theme?: Theme }>`
  box-sizing: border-box;
  border: 1px solid ${({ theme }) => theme.palette.customSecondary.neutral[300]};
  border-radius: 10px;
  max-width: 700px;
  width: 100%;
  height: fit-content;
  background: ${({ theme }) =>
    `linear-gradient(180deg, ${theme.palette.customSecondary.primary.DEFAULT} 0%, ${theme.palette.customSecondary.primary.subtle} 100%)`};
  box-shadow: 0 4px 0 ${({ theme }) => theme.palette.customSecondary.background.surface};
`;

export const StyledClientModal = styled.div<{
  isFullScreen: boolean;
  enableFullScreen: boolean;
  theme?: Theme;
}>`
  display: flex;
  flex-direction: column;
  gap: 16px;
  box-sizing: border-box;
  padding: 0 16px 16px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.customSecondary.neutral[400]};
  border-radius: 16px;
  max-width: calc(100% - 32px);
  width: ${({ isFullScreen }) => (isFullScreen ? '100%' : '900px')};
  max-height: calc(100% - 32px);
  min-height: 0;
  // enableFullScreen has 100% for Ag-Grid rendering purposes
  height: ${({ enableFullScreen }) => (enableFullScreen ? '100%' : 'auto')};
  background: ${({ theme }) => theme.palette.customSecondary.background.raised};
  overflow: auto;
  position: relative;
`;

export const StyledRowWrapper = styled.div<{ theme?: Theme }>`
  position: sticky;
  top: 0;
  left: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  padding-block: 16px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.customSecondary.neutral[300]};
  background: ${({ theme }) => theme.palette.customSecondary.background.raised};
  z-index: 2;
`;

export const StyledIconButton = styled(IconButton)<{ theme?: Theme }>`
  align-self: flex-end;
  color: ${({ theme }) => theme.palette.customSecondary.neutral[200]};
  transition:
    color 0.3s,
    transform 0.3s;

  :hover {
    color: ${({ theme }) => theme.palette.customSecondary.neutral[100]};
    transform: scale(1.2);
  }
`;

export const StyledActionButtonsPanel = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
`;
